import React from "react";
import { ReactComponent as BackIcon } from "assets/img/svg/BackButton.svg";
import IconButtonWrapper from "views/pages/manage/common/form-fields-mui/IconButtonWrapper";
import { useWizard } from "components/wizard/WizardContext";
import VendorType from "./VendorType";
import styles from "../styles.module.scss";
import { useHistory } from "react-router-dom";
import { defaultStreamValues, vendorConfigInitialValues } from "../config";

const WizardTopHeader = ({
    title = "Raise a payment request",
    backIconClickHandler = () => {
        window.close();
    },
}) => {
    const history = useHistory();
    const { current, next, updateValues, setValues } = useWizard();
    const computedTitle = current === 2 ? "Send request for approval" : title;

    return (
        <div className="remove-container-top-space mb-4 d-flex heading-4 color-dark align-items-center justify-content-between top-header-collect-payment"
            style={{ paddingRight: "24px", zIndex: 10000 }}>
            <div className="d-flex align-items-center">
                <IconButtonWrapper
                    onClick={() => {
                        // history.goBack();
                        setValues(vendorConfigInitialValues);
                        backIconClickHandler();
                        next(0);
                    }
                    }>
                    <BackIcon />
                </IconButtonWrapper>
                <div className={styles['header-title']}>{computedTitle}</div>
            </div>
            <VendorType />
        </div>
    );
};

export default WizardTopHeader;
